export interface UserType {
  _id: string;
  email: string;
  password?: string;
  name: string;
  surname: string;
  phone?: string;
  cf?: string;
  liv?: LivEnum;
  role?: RoleEnum;
  readOnly: boolean;
  active?: boolean;
  activateStatus?: boolean;
  resetToken?: string;
  dateResetToken?: Date;
  tenantList?: string[];
  online?: string;
  createdAt?: Date;
  notification_list?: NotificationOptionsType[];
  appAccessList?: AppEnum[];
  tenantsData?: TenantType[];
  notificationCount?: number;
}

export enum LivEnum {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  USER = 'user',
};

export enum RoleEnum {
  COMPLIANCE = 'compliance',
  AT = 'at',
  CSC = 'csc',
  RICHIEDENTE = 'richiedente',
  OR = 'or',
  ADMIN = 'admin',
  GENERIC = 'generic',
}

export interface NotificationType {
  _id: string;
  title: string;
  message: string;
  link : string;
  read: boolean;
  createdAt: string;
  app: AppEnum;
}

export enum AppEnum {
  CONTRATTI = 'contratti',
  PROCEDURE = 'procedure',
  AUDIT = 'audit',
  ACCESSI = 'accessi',
}

export interface TenantType {
  dbName: string;
  name: string;
}

export interface NotificationOptionsType {
  userId?: string | string[];
  ref?: string;
  app: string;
  content?: string;
  send_mail?: boolean;
  emailOptions?: MailOptionsType;
  email_ref?: any;
  seen?: boolean;
}